import { render, staticRenderFns } from "./AnnouncementManage.vue?vue&type=template&id=2988d999&scoped=true&"
import script from "./AnnouncementManage.vue?vue&type=script&lang=ts&"
export * from "./AnnouncementManage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2988d999",
  null
  
)

export default component.exports